import React from 'react'
import PropTypes from 'prop-types'
import SectionHeading from '../../components/SectionHeading/SectionHeading'
import ProvenanceCard from './ProvenanceCard'

export default function Reference({ meta = {}, provenanceSummary = {} }) {
  return (
    <>
      <SectionHeading titleId="AI_RISK_REPORT.SECTION.REFERENCE.TITLE" />
      <ProvenanceCard meta={meta} provenanceSummary={provenanceSummary} />
    </>
  )
}

Reference.propTypes = {
  meta: PropTypes.shape({ generatedAt: PropTypes.string }),
  provenanceSummary: PropTypes.shape({ completenessPct: PropTypes.number, counts: PropTypes.shape({}) }),
}
